import { Col, Row } from 'reactstrap';
import './PerformanceKPI.scss';
import { useState } from 'react';

function PCMKPIHeader() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="description fs-6">
      <Row className="align-items-center">
        {/* Icon + Title + Content */}
        <Col md={11}>
          <p className="mb-2 text-dark">
            <strong className="PCM-heading">Purpose:</strong>{' '}
            <span>This section focuses on</span>{' '}
            <strong>PCM competencies—</strong> <span>the essential</span>{' '}
            <strong>skills, behaviors, and knowledge areas</strong>{' '}
            <span>required to perform your job effectively.</span>
          </p>
          <p className="mb-2 text-dark">
            <strong className="PCM-heading">Key Points:</strong>
          </p>
          <ul className="mb-2 ps-3 text-dark">
            <li className="mb-2">
              <strong className="PCM-heading">PCM Competencies:</strong> These
              are typically broader and more behavior- or capability-oriented
              than performance objectives.
            </li>
            {!expanded && (
              <li style={{ listStyle: 'none' }}>
                <button
                  type="button"
                  className="non-btn see-more-expand"
                  onClick={() => setExpanded(true)}
                >
                  See More
                </button>
              </li>
            )}
            <div className={`expandable-performance ${expanded ? 'open' : ''}`}>
              <li className="mb-2">
                <span>Each competency will be assigned a</span>{' '}
                <strong>weight by your manager,</strong>{' '}
                <span>
                  reflecting how crucial that skill is to your role. The
                </span>{' '}
                <strong>
                  total weight for all competencies in this section must equal
                  40%
                </strong>{' '}
                <span>of your evaluation.</span>
              </li>
              <li className="mb-2">
                <div className="mb-2">
                  <strong className="PCM-heading">Comments:</strong> Similar to
                  the Performance section, each competency includes a comment
                  area. This space is used to:
                </div>
                <ul>
                  <li className="mb-1">
                    Describe how you have demonstrated the competency
                  </li>
                  <li className="mb-1">Give examples of behavior or growth</li>
                  <li className="mb-1">
                    Discuss areas of development or training needs
                  </li>
                  <li>Receive feedback from reviewers</li>
                </ul>
              </li>
            </div>
            {expanded && (
              <li style={{ listStyle: 'none' }}>
                <button
                  type="button"
                  className="non-btn see-more-expand"
                  onClick={() => setExpanded(false)}
                >
                  Hide
                </button>
              </li>
            )}
          </ul>
        </Col>
      </Row>
    </div>
  );
}

export default PCMKPIHeader;
